export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined
    )

export const isRequired = (value) => !value && 'Required'

export const checkboxRequired = (value) => {
  if (
    (Array.isArray(value) && value.length < 1) ||
    (!Array.isArray(value) && !value)
  ) {
    return 'Required'
  }
  return null
}

export const isNumeric = (value) =>
  !/(^[0-9]*$)/.test(value) && 'Must be a number'

export const zip = (value) =>
  !/(^\d{5}$)/.test(value) && 'Must be a valid zipcode'

export const email = (value) => !/.+@.+\..+/.test(value) && 'Invalid email'

export const phone = (value) =>
  !/^[(]?[0-9]{3}[)]?[ .-]?[0-9]{3}[ .-]?[0-9]{4}$/.test(value) &&
  'Invalid number'

export const determineValidations = (field) => {
  const { type, name, required, min, max } = field
  const validations = []

  if (type === 'checkbox' && required) {
    validations.push(checkboxRequired)
  } else if (required) {
    validations.push(isRequired)
  }

  const textTypes = ['text', 'email', 'search', 'password']

  if (type === 'number' && min)
    validations.push((value) => value < min && `Must be at least ${min}`)
  if (type === 'number' && max)
    validations.push((value) => value > max && `Must be less than ${max}`)

  if (textTypes.includes(type) && min)
    validations.push(
      (value) =>
        value && value.length < min && `Must be at least ${min} characters`
    )
  if (textTypes.includes(type) && max)
    validations.push(
      (value) =>
        value && value.length > max && `Must be less than ${max} characters`
    )

  if (type === 'number') validations.push(isNumeric)
  if (type === 'email') validations.push(email)
  if (name === 'zip_postal') validations.push(zip)
  if (type === 'tel') validations.push(phone)

  return composeValidators(...validations)
}
